function generateId(elements, size) {
    for (var i = 0, len = elements.length; i < len; i++) {
        var text = elements[i].innerText || "wrong";
        var id = ("content_" + size + "_" + text)
            .replace(/\s/g, "-")
            .replace(/\./g, "-")
            .toLowerCase();
        elements[i].setAttribute("id", detectIE() ? id : encodeURI(id));
    }
}

function setIds() {
    var elements = document.getElementsByClassName("js-toc-content");

    for (var i = 0, len = elements.length; i < len; i++) {
        var h2 = elements[i].getElementsByTagName("h2");
        var h3 = elements[i].getElementsByTagName("h3");
        var h4 = elements[i].getElementsByTagName("h4");

        generateId(h2, "h2");
        generateId(h3, "h3");
        generateId(h4, "h4");
    }
}

function initToc() {
    tocbot.init({
        tocSelector: ".js-toc",
        contentSelector: ".js-toc-content",
        headingSelector: "h2, h3, h4",
        collapseDepth: 6
    });
}

function setPositionByHeaderPosition() {
    var anchor = $(".js-toc");
    var targetNode = document.getElementsByClassName("navigation-header-container")[0];
    var queryNode = $(targetNode);
    var config = { attributes: true };

// Callback function to execute when mutations are observed
    var callback = function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === "class") {
                if (queryNode.prop("class").indexOf("stuck-show") > 0) {
                    if (!anchor.hasClass("move-down")) {
                        anchor.addClass("move-down");
                    }
                } else {
                    if (anchor.hasClass("move-down")) {
                        anchor.removeClass("move-down");
                    }
                }
            }
        });
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

var debounceFunction = debounce(function (hash) {
    if (history.pushState) {
        history.pushState(null, null, hash);
    } else {
        location.hash = hash;
    }
}, 250);

function handleUrlUpdates() {
    var links = document.getElementsByClassName("toc-link");

    for (var i = 0, len = links.length; i < len; i++) {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === "class") {
                    var elem = $(mutation.target);

                    if (elem.prop("class").indexOf("is-active-link") > 0) {
                        var hashName = elem.prop("href").split("#")[1];
                        var hash = "#" + hashName;
                        if (window.location.hash !== hash) {
                            debounceFunction(hash);
                        }

                        setBorder(elem);
                    } else {
                        elem.css({ paddingLeft: 0, marginLeft: 0 });
                    }
                }
            });
        });

        observer.observe(links[i], {
            attributes: true
        });
    }
}

function setBorder(elem) {
    if (!elem) {
        elem = $(".is-active-link");
    }

    var generalPosition = $(".js-toc").offset().left;
    var currentOffset = elem.offset().left;

    var offset = currentOffset - generalPosition;

    if (offset > 5) {
        elem.css({ paddingLeft: offset - 5, marginLeft: -Math.abs(offset) });
    }
}

function setScrollEvent() {
    var tocElement = $(".js-toc");
    var tocHeight = tocElement.outerHeight();

    var tocContent = $(".js-toc-content");
    var tocContentHeight = tocContent.outerHeight();
    var lock = "";
    var lockTopHeight = "";

    resetLocks();

    window.onscroll = function (e) {
        lockTop();
        lockBottom();
    };

    function resetLocks() {
        var config = { attributes: true, childList: true, subtree: true };
        var callback = function (mutations) {
            mutations.forEach(function () {
                lockBottom(true);
                lockTop();
            });
        };

        var observer = new MutationObserver(callback);
        observer.observe(tocContent[0], config);
    }

    function lockTop() {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var tocBottom = tocElement.offset().top;
        if (lockTopHeight) {
            if (scrollTop > lockTopHeight) {
                tocElement.addClass("is-position-fixed");
            } else {
                tocElement.removeClass("is-position-fixed");
            }
        } else {
            if (scrollTop > tocBottom) {
                lockTopHeight = tocBottom;
                tocElement.addClass("is-position-fixed");
            } else {
                tocElement.removeClass("is-position-fixed");
            }
        }
    }

    function lockBottom(removeBottomLock) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (removeBottomLock) {
            tocElement.removeClass("bottom-lock");
        }

        tocContentHeight = tocContent.outerHeight();

        var tocBottom = tocHeight + tocElement.offset().top;
        var tocContentBottom = tocContentHeight + tocContent.offset().top;
        if (scrollTop < lock) {
            tocElement.removeClass("bottom-lock");
            lock = "";
        } else if (tocBottom + 50 > tocContentBottom) {
            if (!tocElement.hasClass("bottom-lock")) {
                tocElement.addClass("bottom-lock");
                lock = scrollTop;
            }
        } else {
            tocElement.removeClass("bottom-lock");
            lock = "";
        }
    }
}

function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
    }

    var trident = ua.indexOf("Trident/");
    if (trident > 0) {
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
    }

    var edge = ua.indexOf("Edge/");
    if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
    }

    return false;
}

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

(function tableOfContents() {
    var currentLocation = window.location.hash;
    if ($(".js-toc").length) {
        setIds();
        initToc();
        handleUrlUpdates();
        setPositionByHeaderPosition();
        setBorder();
        setScrollEvent();
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            setTimeout(function () {
                location.hash = currentLocation;
            }, 1000);
        }
    }
})();